import { useEffect, useState } from 'react'

import { Handler } from '../../../helpers/typeHelper'
import {
  createEsignPspScreeningDisclosure,
  EsignEnvelopeStatus,
  EsignScreeningDisclosure,
  syncEsignPspScreeningDisclosure,
} from '../../../models/esign'
import { User } from '../../../models/user'
import { useUserProvider } from '../../Context/UserContext'
import { Esign } from '../../Esign/Esign'
import { ExecuteOnMount } from '../../ExecuteOnMount/ExecuteOnMount'
import { InlineSpinner } from '../../Spinner'

interface PspConsentProps {
  onSubmit: Handler
  onBack?: Handler
  user: User
}

export function PspConsent({ user, onSubmit, onBack }: PspConsentProps) {
  const [screeningDisclosure, setScreeningDisclosure] = useState<EsignScreeningDisclosure | null>(null)
  const { showBanner } = useUserProvider()
  const canUseDocusignConsent = user.featureFlags?.publicOnboardingCheckrDocusignConsentFlag

  useEffect(() => {
    if (!canUseDocusignConsent || screeningDisclosure) return

    createEsignPspScreeningDisclosure(user.team)
      .then(setScreeningDisclosure)
      .catch(async (err: any) => {
        showBanner('error', err)
      })
    // Just user id should be here
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.id, user.team])

  if (!canUseDocusignConsent) {
    return <ExecuteOnMount onMount={onSubmit} />
  }

  if (!screeningDisclosure) {
    return <InlineSpinner />
  }

  if (screeningDisclosure.envelope.status === EsignEnvelopeStatus.SIGNED) {
    return <ExecuteOnMount onMount={onSubmit} />
  }

  async function handleSign() {
    try {
      syncEsignPspScreeningDisclosure(user.team)
      onSubmit()
    } catch (err: any) {
      showBanner('error', err)
    }
  }

  return (
    <Esign
      title="Pre-Employment Screening Program"
      url={screeningDisclosure.url}
      vendor={screeningDisclosure.envelope.vendor}
      vendorKey={screeningDisclosure.clientId}
      onSign={handleSign}
      onBack={onBack}
    />
  )
}
